// extracted by mini-css-extract-plugin
module.exports = {"root":"Style_root__NbDBm","showAboveBottomNavbar":"Style_showAboveBottomNavbar__2pB1Y"};